import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {}

export const Container: FC<ContainerProps> = ({ className, ...props }) => (
  <div className={classNames('container px-3 sm:px-4 md:px-6 lg:px-8 xl:px-10 max-w-7xl', className)} {...props} />
);
